import { useQuery } from '@tanstack/react-query';
import { get } from '../../../lib/api';

export const useFetchReportsStatus = () => {
  const { data = { processing_requests: [] } } = useQuery(
    ['reportsStatus'],
    () => get('/client_admin/campaigns/stats_reports'),
  );

  return { data: data.processing_requests };
};
